/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import { useCampaignModulesData } from 'bundles/campaigns/context/CampaignModulesDataContext';
import Section from 'bundles/front-page/components/Section';
import OverflowCarousel from 'bundles/front-page/components/overflow-carousel/OverflowCarousel';
import {
  LOHP_REDESIGN_CUSTOM_TABLET_BREAKPOINT,
  LOHP_REDESIGN_HERO_BANNER_DESKTOP_CARD_WIDTH,
  LOHP_REDESIGN_HERO_BANNER_MOBILE_CARD_WIDTH,
  LOHP_REDESIGN_HERO_BANNER_TABLET_CARD_WIDTH,
} from 'bundles/front-page/constants/defaults';
import HeroBannerPromoCard from 'bundles/front-page/redesign-modules/hero-banner/HeroBannerPromoCard';
import getHeroBannerPromos from 'bundles/front-page/redesign-modules/hero-banner/getHeroBannerPromos';

const styles = {
  carousel: css`
    display: grid;
    grid-template-columns: repeat(3, ${LOHP_REDESIGN_HERO_BANNER_DESKTOP_CARD_WIDTH}px);
    grid-template-rows: 1fr;
    gap: var(--cds-spacing-200);

    @media (max-width: ${LOHP_REDESIGN_CUSTOM_TABLET_BREAKPOINT}px) {
      grid-template-columns: repeat(3, ${LOHP_REDESIGN_HERO_BANNER_TABLET_CARD_WIDTH}px);
    }

    ${breakpoints.down('xs')} {
      grid-template-columns: repeat(3, ${LOHP_REDESIGN_HERO_BANNER_MOBILE_CARD_WIDTH}px);
    }
  `,
};
const HeroBannerSliderModuleRenderer = () => {
  const { campaignData } = useCampaignModulesData();

  const promos = getHeroBannerPromos(campaignData?.heroModule);
  return (
    <Section>
      <OverflowCarousel css={styles.carousel} showNavigationButtons shouldAllowSpaceForHoverItems>
        {promos.map((promo, index) => (
          <HeroBannerPromoCard key={promo.headline} index={index} {...promo} />
        ))}
      </OverflowCarousel>
    </Section>
  );
};

export default HeroBannerSliderModuleRenderer;
